<template>
  <div class="mt-2 d-flex align-center">
    <div class="btn-report-study mr-4" v-if="$route.name === 'StudentDetail'" @click="handleRedirectWeeklyReport">
      <img src="../../../duo_care/assets/homework-report-icon.svg" alt="">
      Báo cáo học tập tuần
    </div>
    <span v-if="$route.name !== 'StudentDetail'">
      <span>
        <strong>Ghi chú: </strong>
      </span>
      <span v-if="textCustom">{{textCustom}} {{dateTimeShow}}</span>
      <span v-else><i>Số điểm, chuyên cần tăng/ giảm của học sinh được so sánh giữa khoảng thời gian được lựa chọn với khoảng từ {{dateTimeShow}}</i></span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    dateTime: {
      type: Array,
      default: () => [],
    },
    lmsCoreUserId: {
      type: Number,
      default: 0,
    },
    textCustom: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    dateTimeShow() {
      const result = this.calculateDateRange(this.dateTime[0], this.dateTime[1]);
      return result;
    },
  },
  methods: {
    handleRedirectWeeklyReport() {
      window.open(`https://${process.env.VUE_APP_VUIHOC_WEB_URL}/tong-hop-bao-cao-buoi-hoc?uid=${btoa(this.lmsCoreUserId)}`);
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    calculateDateRange(startDateStr, endDateStr) {
    // Parse the input date strings to create Date objects
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);

      // Calculate the time difference in milliseconds
      const timeDifference = endDate - startDate;

      // Convert the time difference to days
      const daysDifference = (timeDifference / (1000 * 60 * 60 * 24)) + 1;

      // Calculate the start date for the result period (StartDate back)
      const resultStartDate = new Date(startDate);
      resultStartDate.setDate(startDate.getDate() - daysDifference);

      // Calculate the end date for the result period (StartDate back to one day before)
      const resultEndDate = new Date(startDate);
      resultEndDate.setDate(startDate.getDate() - 1);

      // Display the results in 'DD/MM/YYYY' format
      return `${this.formatDate(resultStartDate)} - ${this.formatDate(resultEndDate)}`;
    },
  },
};
</script>

<style scoped>
.btn-report-study {
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #EAEAEA;
  color: #1289F8;
  width: fit-content;
  padding: 10px 6px;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.2s ease-in-out;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
}
.btn-report-study:hover {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
</style>
